import React from 'react';
import MemoryGame from './MemoryGame';
import './App.css';

function App() {
  return (
    <div className="mg-root">
      <div className="mg-background">
        <div className="mg-shell">
          <header className="mg-header">
            <a className="mg-home-link" href="/">
              <span aria-hidden="true">←</span> Back to Home
            </a>
            <div className="mg-title-block">
              <p className="mg-eyebrow">Mini game</p>
              <h1 className="mg-title">Memory Game</h1>
              <p className="mg-subtitle">
                Flip the cards and match every animal pair as efficiently as you can.
              </p>
            </div>
          </header>
          <MemoryGame />
        </div>
      </div>
    </div>
  );
}

export default App;
